import React from 'react';
import PropTypes from 'prop-types';
import TooltipShadow from 'components/tooltip-shadow';
import {getTranslate} from 'utils/attribute-util';
import Colors from 'common/constants/colors';
import styles from './index.css';

export default class TooltipBackground extends React.Component {
  static propTypes = {
    anchorLength: PropTypes.number,
    anchorWidth: PropTypes.number,
    contentHeight: PropTypes.number,
    contentWidth: PropTypes.number,
    offsetModifier: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    anchorLength: 12,
    anchorWidth: 16,
    contentHeight: 320,
    contentWidth: 240,
    offsetModifier: 0,
    x: 0,
    y: 0,
  };

  static ID = 'tooltipBackground';

  getBoundingClientRect() {
    return this._element.getBoundingClientRect();
  }

  getPathData(
    contentWidth,
    contentHeight,
    anchorLength,
    anchorWidth,
    modifier = 0,
  ) {
    return [
      'M 0 0',
      `H ${contentWidth}`,
      `V ${contentHeight}`,
      `L ${contentWidth / 2 - modifier + anchorWidth / 2} ${contentHeight}`,
      `L ${contentWidth / 2 - modifier} ${contentHeight + anchorLength}`,
      `L ${contentWidth / 2 - modifier - anchorWidth / 2} ${contentHeight}`,
      'H 0',
      'Z',
    ].join(' ');
  }

  render() {
    const pathData = this.getPathData(
      this.props.contentWidth,
      this.props.contentHeight,
      this.props.anchorLength,
      this.props.anchorWidth,
      this.props.offsetModifier,
    );
    return (
      <g
        className={styles.TooltipBackground}
        transform={getTranslate(
          this.props.x + this.props.offsetModifier,
          this.props.y,
        )}>
        <TooltipShadow />
        <use
          fillOpacity={0.4}
          filter={`url(#${TooltipShadow.ID})`}
          ref={(element) => (this._element = element)}
          xlinkHref={`#${TooltipBackground.ID}`}
        />
        <path d={pathData} fill={Colors.gray700} id={TooltipBackground.ID} />
      </g>
    );
  }
}
